import { render, staticRenderFns } from "./size-filter.vue?vue&type=template&id=0047558a&"
import script from "./size-filter.vue?vue&type=script&lang=js&"
export * from "./size-filter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/funday/funday/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0047558a')) {
      api.createRecord('0047558a', component.options)
    } else {
      api.reload('0047558a', component.options)
    }
    module.hot.accept("./size-filter.vue?vue&type=template&id=0047558a&", function () {
      api.rerender('0047558a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/src/components/size-filter/size-filter.vue"
export default component.exports